var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobileOrIPad)?_c('v-progress-circular',{staticClass:"centerize",attrs:{"indeterminate":"","color":"primary","size":50}}):_c('Lottie',{staticClass:"centerize",staticStyle:{"max-width":"600px"},attrs:{"options":_vm.defaultOptions,"height":600,"renderer":"svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }